import React, {useState} from 'react'
import { Link } from "react-router-dom"
import { NavHashLink as Navlink } from "react-router-hash-link"
import logoImg from "../image/logo.png"

import styled from "styled-components"
import media from "styled-media-query"

const Nav = () => {

   const [open, setOpen] = useState(false)

   const toggleOpen = () => {
      if (open) {
         setOpen(false)
      } else if (!open) {
         setOpen(true)
      }
   }

   return (
      <NavStyles open={open}>
         <div className="logo">
            <h1>
               <Link to="/">
                  <img src={logoImg} alt="天心塾"/>
               </Link>
            </h1>
         </div>
         <nav onClick={() => setOpen(false)}>
            <ul>
               <Link to="/">
                  <li>TOP <span>></span></li>
               </Link>
               <Link to="/teachers">
                  <li>講師の紹介 <span>></span></li>
               </Link>
               <Link to="/introduce">
                  <li>塾の紹介 <span>></span></li>
               </Link>
               <Link to="/courses">
                  <li>コース <span>></span></li>
               </Link>
               <Link to="/records">
                  <li>合格実績 <span>></span></li>
               </Link>
               <Navlink smooth to="/#access">
                  <li>アクセス <span>></span></li>
               </Navlink>
               <Navlink smooth to="/#contact">
                  <li>お問い合わせ <span>></span></li>
               </Navlink>
            </ul>
         </nav>
         <div 
            className="menu-bar"
            onClick={toggleOpen}
         >
            <span></span>
            <span></span>
            <span></span>
         </div>
      </NavStyles>
   )
}

const NavStyles = styled.div`
   position: fixed;
   background-color: #fff;
   display: flex;
   justify-content: space-between;
   align-items: center;
   width: 96%;
   height: 60px;
   top: 13px;
   right: 50%;
   transform: translate(50%);
   border-radius: 10px;
   box-shadow: 0 3px 6px #000;
   z-index: 1000;
   
   .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 170px;
      height: 100%;
      border-right: 1px solid #6D6D6D; 
      ${media.lessThan("960px")`
         width: auto;
         margin-left: 10px;
         border: none;
      `}

      img {
         height: 32px;
      }
   }
   
   nav {
      margin-right: 40px;
      color: #6E6E6E;
      ${media.lessThan("960px")`
         position: absolute;
         background-color: #FF3D01CC;
         height: 60vh;
         top: 20px;
         left: -2%;
         left: ${({open}) => open ? "-2%" : "-100%" };
         border-radius: 0 10px 10px 0;
         box-shadow: 3px 3px 6px #0000007A;
         transition: 0.3s;
      `}
      ul {
         display: flex;
         ${media.lessThan("960px")`
            height: 100%;
            flex-direction: column;
            justify-content: space-evenly;
            padding: 30px 50px;
         `}
         a {
            display: block;
            margin-right: 20px;
            ${media.lessThan("960px")`
               margin-right: 0;
            `}
            &:last-child {
               margin-right: 0;
            }

            li {
               font-size: 2rem;
               ${media.lessThan("960px")`
                  color: #fff;
                  text-align: center;
               `}
               &:hover {
                  cursor: pointer;
                  color: #FF3D01;
               }
               span {
                  font-size: 2rem;
                  color: #FF3D01;
                  ${media.lessThan("960px")`
                     display: none;
                  `}
               }
            }
         }
      }
   }

   .menu-bar {
      width: 60px;
      height: 100%;
      background-color: #000;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
      padding: ${({open}) => open ? "30px 0" : "5px 0"};
      display: none;
      border-radius: 0 10px 10px 0;
      transition: 0.3s;
      ${media.lessThan("960px")`
         display: flex;
      `}
      span {
         width: 70%;
         display: block;
         border-bottom: 1px solid #fff;
         transition: 0.3s;
         &:first-child {
            transform: ${({open}) => open ? "rotate(45deg) translate(1px)" : null};
         }
         &:nth-child(2) {
            opacity: ${({open}) => open ? 0 : 1};
         }
         &:last-child {
            transform: ${({open}) => open ? "rotate(-45deg) translate(1px)" : null};
         }
      }
   }
`

export default Nav